import residentialHero from 'assets/neighborhood.jpg'
import * as React from 'react'

import styled from 'style/styled-components'

const StyledMainHeader = styled.h1`
  text-align:center; 
  color:#FFFFFF;
`

const StyledHero = styled.div`
  background: url(${residentialHero}) no-repeat center center;
  background-size: cover;
`

class CreditHeader extends React.Component {
  public render(): JSX.Element {
    return (
      <div>
        <div id="header" className="widget header">
          <a href="">
            <span className="logo icon igs-flag-icon" />
          </a>
          <div id="header-controls">
            <div className="header-controls" />
          </div>
          <div className="links">
            <a className="header-link" id="header-phone" href="tel:1-888-995-0992">
              888.995.0992
            </a>
          </div>
        </div>
        <div className="sfPublicWrapper hero">
          <StyledHero className="hero-img wave widget">
            <div className="hero-content-container">
              <div className="hero-content light-light">
                <div>
                  <StyledMainHeader/> 
                </div>
              </div>
            </div>
          </StyledHero>
        </div>
      </div>
    )
  }
}

export default CreditHeader



// WEBPACK FOOTER //
// ./src/components/creditCheck/creditHeader.tsx